import React, { Component } from "react";
import "./App.css";

const gsh = [
  "001.川岛芳子为啥要害张作霖.mp3",
  "019.世界第一黑.mp3",
  "037.出大事了！高考试卷被盗.mp3",
  "091.洞房容易出奇案.mp3",
  "002牵动中美的寻枪.mp3",
  "020.这座豪宅给鬼住.mp3",
  "074寡妇村的秘密.mp3",
  "092节目不可思议的太空救援.m4a",
  "021.警匪枪战 喋血铁岭.mp3",
  "057.唐伯虎真迹的百年迷踪.mp3",
  '075神奇的"托梦".mp3',
  "093大明海贼王.m4a",
  "022.绝杀三秒钟.mp3",
  "040.中日战争意外的蝴蝶.mp3",
  "058短命的中国驻日占领军.mp3",
  "076.拐卖人贩子.mp3",
  "094大明亡于马.m4a",
  "005世上有没有完美的犯罪？.mp3",
  "023.天才的炸弹怪客.mp3",
  "041.一波三折的洞房奇案.mp3",
  "059.超级侠盗迪林杰.mp3",
  "077明星大盗.mp3",
  "042.最后一个日本兵.mp3",
  "060大哥是这样诞生的.mp3",
  "078.独一无二的登山禁区.mp3",
  "061.天字特号暗杀行动.mp3",
  "079失败的人猿养成计划.mp3",
  "008死人说出的秘密.mp3",
  "026最后一次上朝.mp3",
  "044.神奇的模拟画像.mp3",
  "062杀人的《黑色星期天》.mp3",
  '080这个"英雄"有问题.mp3',
  "098改变国运的股票.m4a",
  "009临刑喊冤 九死余生.mp3",
  "027东海龙王招谁惹谁了.mp3",
  "045.民国黄金舞弊案.mp3",
  "099千古第一邪书罗织经.m4a",
  "010波谲云诡的密码战.mp3",
  "028果戈里幽灵列车.mp3",
  "046.夺回珠穆朗玛.mp3",
  "082.大有皇帝曾应龙.mp3",
  "011十三将士归玉门.mp3",
  "029六寨乌龙惨案.mp3",
  "047.彭加木死在谁手上.mp3",
  "065.大明皇帝的最后一天.mp3",
  "083.旧金山的生化危机.mp3",
  "029六寨乌龙惨案.mp3",
  "048狼人死磕吸血鬼.mp3",
  "013.金庸的江湖.mp3",
  "030.乌克兰魔画.mp3",
  "085.九一八文物盗窃案.mp3",
  "014.孤独的瘟神.mp3",
  "031.哪里来的处女座凶铃.mp3",
  "050.老鼠药虚晃一枪.mp3",
  "068.《雍正王朝》的诞生.mp3",
  "086.留美幼童的故事.mp3",
  "104阎王要你三更死，谁敢留你到五更.m4a",
  "015.谁创造了广东好汉.mp3",
  "016.空袭日本 中美同仇.mp3",
  "033.民国第一选美大赛.mp3",
  "070.巴比伦神像的秘密.mp3",
  "088.白宗巍坠楼.mp3",
  "017.图纸上的炮击天安门.mp3",
  "034越狱之王.mp3",
  "053.两只老鼠的特大间谍案.mp3",
  '071."海地丧尸"的还魂秘术.mp3',
  "089.海昏侯之谜.mp3",
  "035.最后一次剿匪.mp3",
  "054.国宝《游春图》.mp3",
  "072西藏版的生化危机.mp3",
];

const gsh2 = [
  "《老梁故事会》八個凡人八件法寶八段傳奇老梁揭祕八仙.mp3",
  "《老梁故事会》鏢局如何靠三硬橫行明清五百年綠林黑話官.mp3",
  "《老梁故事会》冰心墓碑被親孫子潑紅漆教子無方世紀老人爲.mp3",
  "《老梁故事会》成龍老矣尚能打否老梁揭秘成龍的中年危機與.mp3",
  "《老梁故事会》程咬金真實身份竟是大唐開國猛將史書記載他兩軍.mp3",
  "《老梁故事会》崇禎皇帝到死都不懂的道理每天通宵批奏折親手.mp3",
  "《老梁故事会》從功夫皇帝到好萊塢囚徒李連傑闖蕩美國.mp3",
  "《老梁故事会》從西遊記黑熊怪偷袈裟到吳三桂沖冠壹怒索羅.mp3",
  "《老梁故事会》帝王黑幕贪官皇帝白手套乾隆养和珅赵构.mp3",
  "《老梁故事会》风水师揭秘合集老梁故事匯歷史揭秘懸.mp3",
  "《老梁故事会》給皇帝戴綠帽子的女人有多狠老梁辣評趙姬.mp3",
  "《老梁故事会》古人中年崩潰現場歲辛棄疾帶人闖金營秒.mp3",
  "《老梁故事会》鬼谷子计谋合集老梁故事匯曆史真相歷.mp3",
  "《老梁故事会》皇父秒變叛賊大清開國戰神多爾袞一手扶.mp3",
  "《老梁故事会》精彩故事鬼吹灯合集老梁故事匯曆史真相.mp3",
  "《老梁故事会》老梁扒光職業乞丐十八般武藝祖師爺範丹伍子胥.mp3",
  "《老梁故事会》老梁扒皮退休这笔账小时合集老梁故事匯.mp3",
  "《老梁故事会》老梁爆猛料珍珠港真相竟是被蘇聯間諜美國苦肉.mp3",
  "《老梁故事会》老梁爆笑拆解四大天王真實段位封神裏逼元始天尊.mp3",
  "《老梁故事会》老梁爆笑揭秘美國海軍頭號作死現場新兵蛋子操控.mp3",
  "《老梁故事会》老梁拆穿房價翻倍幻覺房子升值你有錢賬面富.mp3",
  "《老梁故事会》老梁拆穿算命圈性價奸越有錢越信越信越被騙.mp3",
  "《老梁故事会》老梁揭祕封神榜竟是西遊記的前傳哪吒李.mp3",
  "《老梁故事会》老梁揭秘美国海军秘闻小时合集老梁故事.mp3",
  "《老梁故事会》老梁驚天揭祕大鬧天宮北宋版楚門世界.mp3",
  "《老梁故事会》老梁怒揭黑外教產業鏈無證保姆混混.mp3",
  "《老梁故事会》老梁怒揭農村精神真空城裏掃黃草臺班子下鄉鑽.mp3",
  "《老梁故事会》老梁怒撕天價茶遮羞布熊貓糞便抗癌四川綠茶披.mp3",
  "《老梁故事会》老梁深夜炸談納粹寶藏真相大起底法國年只還.mp3",
  "《老梁故事会》老梁撕開種植牙暴利黑幕成本翻倍醫保不報.mp3",
  "《老梁故事会》老梁壹刀見血方孝孺為保名節拉十族陪葬魏征.mp3",
  "《老梁故事会》老梁壹刀見血許仙根本不是暖男而是古代廢柴.mp3",
  "《老梁故事会》老梁壹口氣拆穿清明上河圖三十多個版本大謎團.mp3",
  "《老梁故事会》老梁壹口氣拆光有關部門迷魂陣部委總局.mp3",
  "《老梁故事会》老梁硬核拆解戰狼雇傭兵真相從北府軍到哥薩.mp3",
  "《老梁故事会》老梁震撼揭秘壹條地中海偷渡線半年死人.mp3",
  "《老梁故事会》淚目預警日本每年萬老人孤獨死遺.mp3",
  "《老梁故事会》禮品回收招牌竟是反腐盲區老梁硬核臥底一.mp3",
  "《老梁故事会》兩個億只是入門老梁掀開中國富豪私人飛機土.mp3",
  "《老梁故事会》劉伯溫神機妙算的傳奇人生為何最終難逃悲劇命.mp3",
  "《老梁故事会》六万冤魂的祸因小时合集老梁故事匯曆.mp3",
  "《老梁故事会》年後臺灣首發絕密檔案老梁分鍾拆解戴.mp3",
  "《老梁故事会》千年皇帝小时合集老梁故事匯歷史揭秘.mp3",
  "《老梁故事会》秦始皇陵沈睡千年的秘密為何至今未被打開老梁.mp3",
  "《老梁故事会》热门故事合集系列四十九老梁故事匯曆史.mp3",
  "《老梁故事会》热门故事小时合集蓄谋已久的秘密老梁故事.mp3",
  "《老梁故事会》叔侄搶龍椅真相比權遊還燃老梁硬核拆解明朝.mp3",
  "《老梁故事会》孫悟空拿命賭明天的石猴如何一路砍出血路結拜牛.mp3",
  "《老梁故事会》孫悟空真的反叛嗎西遊記背後隱藏的驚天秘密.mp3",
  "《老梁故事会》唐僧為何西行取經西遊記背後隱藏的驚人真相老.mp3",
  "《老梁故事会》萬件國寶被蔣介石連夜運臺藏在山洞年.mp3",
  "《老梁故事会》窝囊废狠角色沙和尚取經團隊最強大腦.mp3",
  "《老梁故事会》武當派被皇帝捧紅真相大揭秘朱元璋親自上山.mp3",
  "《老梁故事会》武则天不为人知的秘密合集老梁故事匯歷.mp3",
  "《老梁故事会》西遊記背後的狠角色揭秘觀音菩薩與太上老君的真.mp3",
  "《老梁故事会》新版西遊記為何被罵慘老梁犀利解讀四大名著翻拍.mp3",
  "《老梁故事会》億美元家產分鐘分完兄弟零撕逼老梁.mp3",
  "《老梁故事会》雍正暗黑小时合集老梁故事匯歷史真相.mp3",
  "《老梁故事会》雍正被早安轟炸五年成自動回復機器人趙匡胤.mp3",
  "《老梁故事会》雍正何靠候補殺官養廉銀密折微信硬剛.mp3",
  "《老梁故事会》張藝謀與鞏俐影史傳奇情緣那些年我們追過的黃.mp3",
  "《老梁故事会》中國海盜竟比加勒比更傳奇從鄭壹嫂到張保仔從.mp3",
];

const baseUrl = "https://gamemeister.asia";

type Type = "gsh" | "gsh2";

interface State {
  url: string;
  fileName: string;
  type: Type;
  status: "pause" | "play";
  unlocked: boolean;
  clickCount: number;
  showDislikeModal: boolean;
  dislikeTarget: { fileName: string; type: Type } | null;
  dislikedFiles: string[];
  currentTime: number;
  duration: number;
}

export default class Player extends Component<{}, State> {
  private playTimer: NodeJS.Timeout | null = null;
  private playStartTime: number = 0;
  private isAutoPaused: boolean = false; // 标记是否是自动暂停
  private playTimeLogTimer: NodeJS.Timeout | null = null; // 播放时间打印定时器
  private saveProgressTimer: NodeJS.Timeout | null = null; // 保存进度定时器
  private readonly MAX_PLAY_TIME = 3600 * 1000; // 1小时 = 3600000毫秒
  private readonly PROGRESS_KEY = "audio_progress_"; // localStorage key 前缀

  constructor(props: any) {
    super(props);
    const unlocked = localStorage.getItem("player_unlocked") === "true";
    const dislikedFilesStr = localStorage.getItem("disliked_files");
    const dislikedFiles = dislikedFilesStr ? JSON.parse(dislikedFilesStr) : [];
    this.state = {
      url: "",
      fileName: "",
      type: "gsh",
      status: "pause",
      unlocked,
      clickCount: 0,
      showDislikeModal: false,
      dislikeTarget: null,
      dislikedFiles,
      currentTime: 0,
      duration: 0,
    };
  }

  playedCnt = 0;

  handleCornerClick = () => {
    const { clickCount } = this.state;
    const newCount = clickCount + 1;

    if (newCount >= 6) {
      localStorage.setItem("player_unlocked", "true");
      this.setState({ unlocked: true, clickCount: 0 });
    } else {
      this.setState({ clickCount: newCount });
    }
  };

  handleTitleDoubleClick = (e: React.MouseEvent, type: Type) => {
    e.preventDefault();
    e.stopPropagation();
    const { fileName } = this.state;
    console.log(
      "handleTitleDoubleClick triggered, filename:",
      fileName,
      "type:",
      type
    );
    this.setState({
      showDislikeModal: true,
      dislikeTarget: fileName ? { fileName, type } : null,
    });
  };

  handleDislike = () => {
    const { dislikeTarget, dislikedFiles } = this.state;
    if (dislikeTarget) {
      const newDislikedFiles = [...dislikedFiles, dislikeTarget.fileName];
      localStorage.setItem("disliked_files", JSON.stringify(newDislikedFiles));
      this.setState({
        dislikedFiles: newDislikedFiles,
        showDislikeModal: false,
        dislikeTarget: null,
      });

      // 如果当前正在播放被标记为不喜欢的音频，切换到下一个
      const { fileName, type } = this.state;
      if (fileName === dislikeTarget.fileName && type === dislikeTarget.type) {
        this.randomPlay(type);
      }
    }
  };

  handleCloseModal = () => {
    this.setState({
      showDislikeModal: false,
      dislikeTarget: null,
    });
  };

  onPlayCb() {
    // 只有在自动暂停后再次播放时，才重置计时器
    if (this.isAutoPaused) {
      this.isAutoPaused = false;
      this.playStartTime = Date.now();
      this.clearPlayTimer();

      // 设置定时器，1小时后自动暂停
      this.playTimer = setTimeout(() => {
        const audio = document.getElementById(
          "audioPlayer"
        ) as HTMLAudioElement;
        if (audio && !audio.paused) {
          audio.pause();
          this.isAutoPaused = true;
          this.setState({ status: "pause" });
        }
        this.clearPlayTimer();
      }, this.MAX_PLAY_TIME);
    } else {
      // 如果计时器还没有启动，则启动计时器
      if (!this.playTimer) {
        this.playStartTime = Date.now();
        this.playTimer = setTimeout(() => {
          const audio = document.getElementById(
            "audioPlayer"
          ) as HTMLAudioElement;
          if (audio && !audio.paused) {
            audio.pause();
            this.isAutoPaused = true;
            this.setState({ status: "pause" });
          }
          this.clearPlayTimer();
        }, this.MAX_PLAY_TIME);
      } else {
        // 如果计时器已经启动，计算剩余时间并更新定时器
        const elapsed = Date.now() - this.playStartTime;
        const remaining = this.MAX_PLAY_TIME - elapsed;

        if (remaining > 0) {
          // 清除旧的定时器，使用剩余时间设置新的定时器
          this.clearPlayTimer();
          this.playTimer = setTimeout(() => {
            const audio = document.getElementById(
              "audioPlayer"
            ) as HTMLAudioElement;
            if (audio && !audio.paused) {
              audio.pause();
              this.isAutoPaused = true;
              this.setState({ status: "pause" });
            }
            this.clearPlayTimer();
          }, remaining);
        }
      }
    }

    // 启动播放时间打印定时器
    this.startPlayTimeLog();
    // 启动进度保存定时器
    this.startSaveProgress();

    this.setState({ status: "play" });
  }

  onPauseCb() {
    // 手动暂停时不清除计时器，保持计时继续
    // 只有自动暂停时才会设置 isAutoPaused 标志
    // 停止播放时间打印
    this.stopPlayTimeLog();
    // 停止进度保存定时器并保存当前进度
    this.stopSaveProgress();
    const { fileName, type } = this.state;
    if (fileName) {
      const audio = document.getElementById(
        "audioPlayer"
      ) as HTMLAudioElement;
      if (audio) {
        this.saveProgress(fileName, type, audio.currentTime);
      }
    }
    this.setState({ status: "pause" });
  }

  clearPlayTimer() {
    if (this.playTimer) {
      clearTimeout(this.playTimer);
      this.playTimer = null;
    }
  }

  formatPlayTime(ms: number): string {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours > 0) {
      return `${hours}小时${minutes}分钟${seconds}秒`;
    } else if (minutes > 0) {
      return `${minutes}分钟${seconds}秒`;
    } else {
      return `${seconds}秒`;
    }
  }

  formatSeconds(seconds: number): string {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    const pad = (n: number) => n.toString().padStart(2, "0");

    if (hrs > 0) {
      return `${pad(hrs)}:${pad(mins)}:${pad(secs)}`;
    } else {
      return `${pad(mins)}:${pad(secs)}`;
    }
  }

  startPlayTimeLog() {
    // 清除之前的定时器
    this.stopPlayTimeLog();

    // 立即打印一次
    this.logPlayTime();

    // 每秒打印一次播放时间
    this.playTimeLogTimer = setInterval(() => {
      this.logPlayTime();
    }, 1000);
  }

  stopPlayTimeLog() {
    if (this.playTimeLogTimer) {
      clearInterval(this.playTimeLogTimer);
      this.playTimeLogTimer = null;
    }
  }

  logPlayTime() {
    if (this.playStartTime > 0) {
      const elapsed = Date.now() - this.playStartTime;
      const formattedTime = this.formatPlayTime(elapsed);
      const remaining = this.MAX_PLAY_TIME - elapsed;
      const formattedRemaining =
        remaining > 0 ? this.formatPlayTime(remaining) : "0秒";

      console.log(
        `播放时间: ${formattedTime} | 剩余时间: ${formattedRemaining}`
      );
    }
  }

  // 获取音频进度的 localStorage key
  private getProgressKey(fileName: string, type: Type): string {
    return `${this.PROGRESS_KEY}${type}_${fileName}`;
  }

  // 保存播放进度到 localStorage
  private saveProgress(fileName: string, type: Type, currentTime: number) {
    if (!fileName || currentTime <= 0) return;
    const key = this.getProgressKey(fileName, type);
    const data = {
      currentTime,
      savedAt: Date.now(),
    };
    localStorage.setItem(key, JSON.stringify(data));
  }

  // 从 localStorage 读取播放进度
  private getProgress(fileName: string, type: Type): number {
    if (!fileName) return 0;
    const key = this.getProgressKey(fileName, type);
    const data = localStorage.getItem(key);
    if (!data) return 0;
    try {
      const parsed = JSON.parse(data);
      return parsed.currentTime || 0;
    } catch {
      return 0;
    }
  }

  // 开始定期保存进度
  private startSaveProgress() {
    this.stopSaveProgress();
    this.saveProgressTimer = setInterval(() => {
      const { fileName, type } = this.state;
      if (fileName) {
        const audio = document.getElementById(
          "audioPlayer"
        ) as HTMLAudioElement;
        if (audio && audio.currentTime > 0) {
          this.saveProgress(fileName, type, audio.currentTime);
        }
      }
    }, 5000); // 每5秒保存一次
  }

  // 停止保存进度
  private stopSaveProgress() {
    if (this.saveProgressTimer) {
      clearInterval(this.saveProgressTimer);
      this.saveProgressTimer = null;
    }
  }

  randomFile(type: Type) {
    let arr: string[] = [];
    if (type === "gsh") {
      arr = gsh;
    } else if (type === "gsh2") {
      arr = gsh2;
    }

    // 过滤掉不喜欢的音频
    const { dislikedFiles } = this.state;
    arr = arr.filter((file) => !dislikedFiles.includes(file));

    if (arr.length === 0) {
      // 如果所有音频都被标记为不喜欢，返回空字符串
      return "";
    }

    const index = Math.floor(Math.random() * arr.length);
    const fileName = arr[index];
    return fileName;
  }

  randomPlay(type: Type) {
    this.setState({ type });
    const fileName = this.randomFile(type);
    const encodedFileName = encodeURIComponent(fileName);
    const url = `${baseUrl}/${type}/${encodedFileName}`;
    console.log("url--->", url);
    this.setState({ url, fileName, currentTime: 0, duration: 0 }, () => {
      const audio = document.getElementById("audioPlayer") as HTMLAudioElement;
      if (audio) {
        // 恢复上次播放进度
        const savedTime = this.getProgress(fileName, type);
        if (savedTime > 0) {
          audio.currentTime = savedTime;
          console.log(`恢复播放进度: ${fileName} -> ${savedTime}秒`);
        }
        audio?.play();
      }
    });
  }

  toPlayOrPause(renderType: Type) {
    const { type } = this.state;
    if (type !== renderType) {
      this.setState({ type: renderType });
      this.randomPlay(renderType);
      return;
    }

    const { url } = this.state;
    const audio = document.getElementById("audioPlayer") as HTMLAudioElement;
    const paused = audio.paused;
    if (url) {
      if (paused) {
        audio.play();
      } else {
        audio.pause();
      }
    } else {
      this.randomPlay(type);
    }
  }

  onEndedCb() {
    const { fileName, type } = this.state;
    // 播放完成时清除该音频的进度记录
    if (fileName) {
      const key = this.getProgressKey(fileName, type);
      localStorage.removeItem(key);
    }
    this.playedCnt++;
    if (this.playedCnt < 3) {
      this.randomPlay(type);
    } else {
      this.playedCnt = 0;
    }
  }

  getTitle(type: Type) {
    if (type === "gsh2") {
      return "老梁故事会2";
    }
    return "老梁故事会";
  }

  _renderTemplate(type: Type) {
    return (
      <div className="card">
        <p
          className="title"
          style={{
            userSelect: "none",
            cursor: "pointer",
            WebkitUserSelect: "none",
          }}
        >
          {this.getTitle(type)}
        </p>
        <p>暂未开始</p>
        <div className="icons">
          <div
            id="playIcon"
            className={`icon pause`}
            onClick={() => {
              this.toPlayOrPause(type);
            }}
          />
          <div className="blank" />
          <div
            className="icon next"
            onClick={() => {
              this.randomPlay(type);
            }}
          />
        </div>
      </div>
    );
  }

  _renderCard(renderType: Type) {
    const { fileName, status, type } = this.state;
    if (type !== renderType) {
      return this._renderTemplate(renderType);
    }

    const { currentTime, duration } = this.state;

    return (
      <div className="card">
        <p className="title">{this.getTitle(renderType)}</p>
        <p
          onClick={(e) => {
            console.log("onDoubleClick triggered in _renderTemplate");
            this.handleTitleDoubleClick(e, type);
          }}
        >
          {fileName ? fileName : "暂未开始"}
        </p>
        {fileName && duration > 0 && (
          <p style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
            {this.formatSeconds(currentTime)} / {this.formatSeconds(duration)}
          </p>
        )}
        <div className="icons">
          <div
            id="playIcon"
            className={`icon ${status}`}
            onClick={() => {
              this.toPlayOrPause(renderType);
            }}
          />
          <div className="blank" />
          <div
            className="icon next"
            onClick={() => {
              this.randomPlay(renderType);
            }}
          />
        </div>
      </div>
    );
  }

  componentDidMount(): void {
    // alert(document.body.clientHeight)
  }

  componentWillUnmount(): void {
    // 组件卸载时清理定时器
    this.clearPlayTimer();
    this.stopPlayTimeLog();
    this.stopSaveProgress();
  }

  render() {
    const { url, unlocked, showDislikeModal } = this.state;

    if (!unlocked) {
      return (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#000000",
            }}
          >
            <div
              style={{
                fontSize: "48px",
                fontWeight: "bold",
                color: "#FFE4C4",
                textAlign: "center",
                userSelect: "none",
              }}
            >
              加载失败
            </div>
          </div>
          <div
            style={{
              position: "fixed",
              bottom: 0,
              right: 0,
              width: "100px",
              height: "100px",
              cursor: "pointer",
              zIndex: 9999,
            }}
            onClick={this.handleCornerClick}
          />
        </>
      );
    }

    return (
      <>
        <div className="cards">
          <audio
            id="audioPlayer"
            // controls
            src={url}
            onPlay={() => {
              this.onPlayCb();
            }}
            onPause={() => {
              this.onPauseCb();
            }}
            onEnded={() => {
              this.onEndedCb();
            }}
            onTimeUpdate={(e) => {
              this.setState({ currentTime: e.currentTarget.currentTime });
            }}
            onLoadedMetadata={(e) => {
              this.setState({ duration: e.currentTarget.duration });
            }}
          ></audio>
          {this._renderCard("gsh2")}
          {this._renderCard("gsh")}
        </div>
        {showDislikeModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 10000,
            }}
            onClick={this.handleCloseModal}
          >
            <div
              style={{
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "8px",
                minWidth: "200px",
                textAlign: "center",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <p style={{ marginBottom: "20px", fontSize: "16px" }}>操作选项</p>
              {this.state.dislikeTarget ? (
                <button
                  onClick={this.handleDislike}
                  style={{
                    padding: "10px 20px",
                    backgroundColor: "#ff4444",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "14px",
                    marginRight: "10px",
                  }}
                >
                  我不喜欢
                </button>
              ) : (
                <p
                  style={{
                    marginBottom: "10px",
                    color: "#666",
                    fontSize: "14px",
                  }}
                >
                  请先播放音频
                </p>
              )}
              <button
                onClick={this.handleCloseModal}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#ccc",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                取消
              </button>
            </div>
          </div>
        )}
      </>
    );
  }
}
